
import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import Navbar from "../../../components/Navbar.js";
import Select from "react-select";
import LOGO from "../../../assets/images/logo.png";
import SignatureCanvas from 'react-signature-canvas';
import Pagination from '@mui/material/Pagination';
import {
    locale,
    tokens,
    select_style,
    required,
    // alert
    success,
    success_url,
    alert,
    alert_url,
    // function
    logout,
    number_zero,
    format_date,
    toFixed,
    total,
    validate,
    random_charactor,
    float,
    // api
    GET,
    POST,
    PUT,
    DELETE,
    error_message,
    // storage
    removeStorage,
    getStorage,

    validate_email,
    validate_th,
    validate_en,
    validate_en_number,

    LinktoBase64,
    // component
    DatePicker,
} from "../../../components/CustomComponent.js";

import "../../../components/global.js";
import "../../../assets/css/bootstrap.css";
import "../../../assets/css/index.css";

export default class Dashboard extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            data_item: null,
            data_stock: null,

            page: 1,
            data_search: "",

            product_id: "",
            item: null
        }
    }
    async componentDidMount() {
        await this.Get();
    }
    Get = async () => {
        this.setState({ loading: true });
        let body = {
            page: 0,
            data_search: this.state.data_search
        }
        let result = await GET(tokens, "v1/TH/stock-manage/log/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result);
            this.setState({
                data_item: result.data.stock_item,
                data_stock: result.data.stock_log
            });
        }
        this.setState({ loading: false });
    }
    render() {
        return (
            <div className="w-100 min-vh-100 fade-in">
                {this.state.loading && (<div className="spinner-container"> <div className="loading-spinner"></div> </div>)}
                <Navbar page1="หน้าหลัก" page2="จัดการสต๊อก" page3="ประวัติสต๊อก" />
                {/* BODY */}
                <div className="body bg-light min-vh-100">
                    <div className="p-3">
                        {/* หัวข้อ และ ปุ่มเพิ่ม */}

                        <div className="row">
                            <div className="col-12 col-md-4">
                                <div className="d-flex mx-0 align-items-center justify-content-between test mb-2 flex-wrap">
                                    <h3 className="mb-2"><b>ประวัติสต๊อก</b></h3>
                                </div>
                                <div className="w-100 card border-0 p-0 rounded-lg">
                                    <div className="table-responsive" style={{ height: "80vh" }}>
                                        <table className="table table-borderless table-striped table-hover">
                                            <thead className="bg-primary">
                                                <tr>
                                                    <th className="text-left text-white">รายการ</th>
                                                    <th className="text-center text-white">จำนวนปัจจุบัน</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.data_item && this.state.data_item.map((item, index) => (
                                                    <tr className="pointer" key={index} onClick={() => { this.setState({ product_id: item.product_id, item: item }) }}>
                                                        <td className="text-left">{item ? item.product_name : "-"}</td>
                                                        <td className="text-center">{item.quantity ? item.quantity : "0"}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-md-8">
                                <div className="d-flex mx-0 align-items-center justify-content-between test mb-2 flex-wrap">
                                    <h3 className="mb-2"><b>{this.state.item ? this.state.item.product_name : "-"}</b></h3>
                                </div>
                                <div className="w-100 card border-0 p-0 rounded-lg">
                                    <div className="table-responsive">
                                        <table className="table table-borderless table-striped">
                                            <thead className="bg-primary">
                                                <tr>
                                                    <th className="text-center text-white">บันทึกข้อมูลจาก</th>
                                                    <th className="text-center text-white">เข้า/ออก</th>
                                                    <th className="text-left text-white">คลังสินค้า</th>
                                                    <th className="text-center text-white">อ้างอิง</th>
                                                    <th className="text-center text-white">บันทึกเมื่อ</th>
                                                    <th className="text-left text-white">ผู้บันทึก</th>
                                                    <th className="text-left text-white">หมายเหตุ</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.data_stock && this.state.data_stock.filter(e => e.product_id === this.state.product_id).map((item, index) => (
                                                    <tr key={index}>
                                                        <td className="text-center">{item.log_type_name ? item.log_type_name : "-"}</td>
                                                        <td className="text-center">{item.quantity ? item.quantity : "-"}</td>
                                                        <td className="text-left">{item.warehouse_name ? item.warehouse_name : "-"}</td>
                                                        <td className="text-center">{item.ref ? item.ref : "-"}</td>
                                                        <td className="text-center">{item.datetime_create ? format_date(item.datetime_create, "dd/mm/yyyy hh:mm") : "-"}</td>
                                                        <td className="text-left">{item.created_by ? item.created_by : "-"}</td>
                                                        <td className="text-left">{item.remark ? item.remark : "-"}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div >
        )
    }
}
